module.exports = __webpack_public_path__ + "media/images/front/treatment_support/mv_appeal_sp-0ed9e79b569c3d99d534eb2fa729acfa.png";